import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'management-reports-sales-products-revenue-stream',
  storeModule.createStoreModule('management-reports-sales-products-revenue-stream')
)
